import { RequestPrepaid, RequestPrepaidControllerApi } from '../client';
import { AxiosResponse } from 'axios';
import {getTokenFromStorage} from "../utils/GetTokenFromStorage";

export const useRequestPrepaidServices = () => {
	const services = new RequestPrepaidControllerApi();
	const sendRequestPrepaid = async (requestPrepaid: any): Promise<AxiosResponse<any>> => {
		//temporary object to be used in an api for test (MUST CHANGE)
		const token = getTokenFromStorage();
		let embeddedRequestPrepaid : RequestPrepaid = {
			firstname: requestPrepaid.firstname,
			lastname: requestPrepaid.lastname,
			rut: requestPrepaid.rut,
			renta: requestPrepaid.renta,
			phone: requestPrepaid.phone,
			email: requestPrepaid.email,
			financiera: requestPrepaid.financiera,
			operacion: requestPrepaid.operacion,
			emailFinanciera: requestPrepaid.emailFinanciera,
			rutFinanciera: requestPrepaid.rutFinanciera,
			patente: requestPrepaid.patente,
			origen: requestPrepaid.origen,
			base64: requestPrepaid.base64,
			fileName: requestPrepaid.fileName,
		}
		return services.createRequestPrepaidUsingPOST(
			token,
			embeddedRequestPrepaid
		);
	}

	return { sendRequestPrepaid } as const;

}